import { AxiosResponse } from 'axios';
import { Log } from 'src/admin-entity/interface/log/logs.interface';
import { GiftOrderItem } from 'src/admin-entity/interface/order/gift/gift-order-item.interface';
import { BASE_URL } from './../config/api';
import client from './client';

export const getGiftItemDetail = (id: number): Promise<AxiosResponse<GiftOrderItem>> =>
    client.get(`${BASE_URL}/v1/admin/gift/group/${id}`);

export const getGiftPriceHistory = (id: number): Promise<AxiosResponse<any>> =>
    client.get(`${BASE_URL}/v1/admin/gift/group/${id}/order-price-history`);

export const getGiftMemo = (id: number): Promise<AxiosResponse<{ adminMemo: string }>> =>
    client.get(`${BASE_URL}/v1/admin/gift/group/${id}/admin-memo`);

export const updateGiftMemo = (id: number, adminMemo: string): Promise<AxiosResponse<any>> =>
    client.put(`${BASE_URL}/v1/admin/gift/group/${id}/admin-memo`, {
        adminMemo,
    });

export const getGiftHistory = (id: number): Promise<AxiosResponse<Log[]>> =>
    client.get(`${BASE_URL}/v1/admin/log/gift-group/${id}`);

export const withdrawGiftGroupAllOrderItem = (id: number): Promise<AxiosResponse<any>> =>
    client.put(`${BASE_URL}/v1/admin/order-items/gift-group/${id}/withdraw`);
